import AbstractStore from './AbstractStore';

export default class KeyValueStore extends AbstractStore {
    constructor() {
        super(['load', 'set', 'unset', 'add', 'remove']);

        this.values = {};
    }
    load(values)
    {
        this.actions.load(values);
    }
    set(key, value)
    {
        this.actions.set(key, value);
    }
    unset(key)
    {
        this.actions.unset(key);
    }
    add(key, value)
    {
        this.actions.add(key, value);
    }
    remove(key, value)
    {
        this.actions.remove(key, value);
    }
    onLoad(values)
    {
        if (typeof values !== 'object') {
            values = {};
        }
        this.values = values;
        this.trigger(this.values);
    }
    onSet(key, value)
    {
        this.values[key] = value;
        this.trigger(this.values);
    }
    onAdd(key, value)
    {
        if (typeof this.values[key] == 'undefined') this.values[key] = [];
        else this.onRemove(key, value);
        this.values[key].push(value);
        this.trigger(this.values);
    }
    onUnset(key)
    {
        if (typeof this.values[key] !== 'undefined') {
            delete this.values[key];
            this.trigger(this.values);
        }
    }
    onRemove(key, value)
    {
        if (typeof this.values[key] !== 'undefined') {
            this.values[key] = this.values[key].filter(function (val) {
                return val !== value;
            }, this);
            this.trigger(this.values);
        }
    }
}



// WEBPACK FOOTER //
// ./src-js/Fratello/Common/Stores/KeyValueStore.jsx